// Override Settings
var readyRender = false;
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		activeFilterScrollbar: 'browser',
    	//paginationType: 'load_more', 
    	hybridPagination: true, 
    	paginationType: 'default'
	}
};
var currencyCode = '';
if (Currency.currentCurrency != 'AUD') {
	currencyCode = ' '+Currency.currentCurrency;
}
currencyCode = Shopify.currency.active;
var metaTitle = '';
var metaSubTitle = '';
var metaFormattedTitle = '';
var paginationHtml2 = '';

// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml':  '<article class="product--root bcf" {{dataHoverImage}} data-tag="{{productTags}}">' +
								'{{itemLabels}}' +
								'<div class="productImgBox">'+ 
								'<a href="{{itemUrl}}">' +
									'<div class="product--image-wrapper">' +
										'<div class="product-label-main">{{labelTags}}</div>' +
										'<div class="product--image">' +
											'{{itemImage}}' +
										'</div>' +
										'{{itemHoverImage}}' +
									'</div>' +
								'</a>' +
									
								'</div>' +
								'<div class="product--details">' +
								'<div class="product--details-inner">' +
									'<a href="{{itemUrl}}">' +
										'<div class="product--title">{{itemTitle}}</div>' +
										'{{itemReviews}}' +
									'</a>' +
									'{{itemVendor}}' +
									'{{judgeme}}' +
									'<div class="judge-me-review-block" data-handle="{{itemHandle}}"></div>' +
									'<a href="{{itemUrl}}">' +
										'<div class="product--price-wrapper">' +
											'{{itemPrice}}' +
										'</div>' +
										'{{discountPercentage}}' +
										'{{sustainTag}}' +
									'</a>' +
								'</div>' +	
								'</div>' +
								'<div class="collection-grid-product-form product-page--cart-form-block {{withSize}}" data-id="{{itemId}}" data-discount-mod="{{discountMod}}" data-fixed-discount-price="{{fixedPrice}}">' +
									'{{productForm}}' +
								'</div>' +
							'</article>',
	// Pagination Template
	'previousActiveHtml': '<li class="arrow prev"><a href="{{itemUrl}}">'+ boostPFSConfig.label.pagination_previous +'</a></li>',
	'previousDisabledHtml': '<li class="arrow prev unavailable"><a href="">'+ boostPFSConfig.label.pagination_previous +'</a></li>',
	'nextActiveHtml': '<li class="arrow next"><a href="{{itemUrl}}">'+ boostPFSConfig.label.pagination_next +'</a></li>',
	'nextDisabledHtml': '<li class="arrow next unavailable"><a href="">'+ boostPFSConfig.label.pagination_next +'</a></li>',
	'firstActiveHtml': '<li class="arrow first first"><a href="{{itemUrl}}">First Page</a></li>',
	'firstDisabledHtml': '<li class="arrow first unavailable first"><a href="">First Page</a></li>',
	'lastActiveHtml': '<li class="arrow last"><a href="{{itemUrl}}">Last Page</a></li>',
	'lastDisabledHtml': '<li class="arrow unavailable last"><a href="">Last Page</a></li>',

	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="current"><a href="">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li class="unavailable"><a href="">{{itemTitle}}</a></li>',
	'paginateHtml': '{{first}}{{previous}}{{pageItems}}{{next}}{{last}}',
	'paginateWord': 'Page {{selectBox}} of {{totalPage}}',	
	'paginateHtml2': '{{previous}}<li class="overall-pagination">PAGE {{selectBox}} OF {{totalPage}}</li>{{next}}',

	// Sorting Template
	'sortingHtml': '<select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};


(function ($) {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		//console.log(data);
		//console.log(data.options.length);

		
		
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = false;

		//console.log('compare:'+data.compare_at_price_min);
		//console.log('price:'+data.price_min);

		if (data.compare_at_price_min != null) {
			onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		}
		
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

	
		// Add data hover image
		var dataHoverImage = boostPFSConfig.custom.hover_image_enable ? 'data-hover-image="true"' : '';
		itemHtml = itemHtml.replace(/{{dataHoverImage}}/g, dataHoverImage);

		// Add Labels
		var itemLabelsHtml = '';
		if (soldOut) {
			itemLabelsHtml += '<a href="{{itemUrl}}">';
			itemLabelsHtml += '<div class="product--sold-out font--accent"><span>';
			if (data.tags.indexOf('coming_soon') >= 0) {
				itemLabelsHtml = '<div class="product--sold-out font--accent"><span>' + theme.translations.coming_soon + '</span></div>';
			} else {
				itemLabelsHtml += theme.translations.sold_out;
			}
			itemLabelsHtml += '</span></div>';
			itemLabelsHtml += '</a>';
		} else if (onSale) {
			itemLabelsHtml += '<a href="{{itemUrl}}">';
			itemLabelsHtml += '<div class="product--sale font--accent" href=""><span>';
			itemLabelsHtml += boostPFSConfig.label.sale;
			itemLabelsHtml += '</span></div>';
			itemLabelsHtml += '</a>';
		}
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

		

		// Add Tag Labels
		var availableTags = data.tags;
		var selectedLabelTags = theme.labelSettings.selectedTags.split(',');
		var labelLimit = parseInt(theme.labelSettings.labelLimit);
		var tagSpans = '';
		var tagsAdded = 0;
		for (var x = 0; x < selectedLabelTags.length; x++) {
			if (availableTags.indexOf(selectedLabelTags[x]) > -1) {
				tagSpans += '<span class="product-label">' + selectedLabelTags[x] + '</span>';
				tagsAdded += 1;
			}

			if (tagsAdded == labelLimit) {
				break;
			}
		}

		if (tagsAdded > 0 && data.available == true && onSale == false) {
			itemHtml = itemHtml.replace(/{{labelTags}}/g, tagSpans);	
		} else {
			itemHtml = itemHtml.replace(/{{labelTags}}/g, '');	
		}

		// Add Image
		itemHtml = itemHtml.replace(/{{itemImage}}/g, buildItemImage(data, 'image'));
	
		// Add Vendor
		var itemVendorHtml = '';
		if (boostPFSConfig.custom.vendor_enable) {
			itemVendorHtml += '<p class="vendor"><a href="' + Utils.buildProductItemVendorUrl(data.vendor) + '">' + data.vendor + '</a>'
		}
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Replace item handle
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);

		

		// Add Price
		var itemPriceHtml = '';
		
		//console.log('itemPriceHtml', data.title, data.compare_at_price_min, data.price_min, data); 
		/*
		if (onSale) {
			itemPriceHtml += '<span class="product--compare-price aaa">' + 
								'<span class="money"  data-currency="'+Currency.currentCurrency+'">' + Utils.formatMoney(data.compare_at_price_min) +currencyCode+ '</span>' +
							'</span>' +
							'<span class="product--price price-on-sale">' +
								'<span class="money"  data-currency="'+Currency.currentCurrency+'">' + Utils.formatMoney(data.price_min) +currencyCode+ '</span>' +
							'</span>';
		} else {
			if (priceVaries) {
				itemPriceHtml += '<span class="product--from">' + boostPFSConfig.label.from_price + ' </span>';
			}
			itemPriceHtml += '<span class="product--price"><span class="money" data-currency="'+Currency.currentCurrency
+'">' + Utils.formatMoney(data.price_min) +currencyCode+ '</span></span>';
		}
		*/
		//console.log(itemPriceHtml)
		// Bundle Price
		//var bundlePriceContainer = '<div class="collection-bundle-price" data-url="' + Utils.buildProductItemUrl(data) + '"></div>'

		// loop variant metafields
		//console.log(data.metafields);
		var saleClass = '';
		metaTitle = '';
		metaSubTitle = '';
		var sustainTag = '';
		var discountMod = 1;
		var fixedPrice = 0;
		metaFormattedTitle = '<strong>'+data.title+'</strong>';
		if ($.inArray('sustainable', data.tags) > -1) {
			sustainTag = '<div><small>Sustainable</small></div>';
		}
		//console.log('bundlr', data.title, data.metafields);


		$.each(data.metafields, function( key, value ) {
			if (value.key == 'title') {
				metaTitle = value.value;
			}	
			if (value.key == 'subtitle') { 
				metaSubTitle = value.value;
			}	
			if (value.key == 'benefits') {
				sustainTag = '<div class="benefits"><small>'+value.value+'</small></div>';
			}	

			if (value.namespace == 'judgeme') {
				if (value.namespace == 'judgeme') {
					//console.log('JJJJJ', data.title, value.value);
					itemHtml = itemHtml.replace(/{{judgeme}}/g, value.value);
				}	
			}	
			/*
			if (value.key == 'discounted_fixed_price') {
				fixedPrice = parseInt(value.value);
				var percentageValue = data.price_min - fixedPrice;
				percentageValue = percentageValue * 100;
				percentageValue = percentageValue / data.price_min;
				percentageValue = Math.round(percentageValue);
				if (percentageValue > 0) {
					var discountPrecentageBlockCustom = '<div class="discount-percentage-block2">' + percentageValue + theme.translations.percentage_off +'</div>'; 
					itemHtml = itemHtml.replace(/{{discountPercentage}}/g, discountPrecentageBlockCustom);
				}
			}
			*/
		});	
		if (metaTitle != '' && metaSubTitle != '') {
			metaFormattedTitle = '<strong>'+metaTitle+'</strong><div><span>'+metaSubTitle+'</span></div>';
		}
		

		var xPrice;
		var listPrice = 0;
		var comparePrice = 0;
		var bundleFlag = false;
		var priceType = 'Normal';
		var discountPercentage = 0;
		var customFixedPrice = 0;
		console.log('bundlrPercentageModifier bbb', data.title,  data.metafields);
		$.each(data.metafields, function( key, value ) {
			if (value.key == 'bundle_custom_price') {
				itemPriceHtml = '';
				listPrice = value.value;
				itemPriceHtml = '<div class="customBundlePrice"><span class="product--from customPrice">From </span><span class="product--price customPrice"  type="bundlePrice">'+customMoney(parseFloat(value.value))+'</span></div>';	  
		  		bundleFlag = true;
		  		priceType = 'Bundle Custom';
		  		//console.log('mmm bundle_custom_price', listPrice); 
		  	}
		  	if (value.key == 'bundle_custom_compare_price') {
		  		itemPriceHtml = '';
		    	comparePrice = value.value;	
		    	xPrice = xPrice;
		    	//console.log('mmm bundle_custom_compare_price', comparePrice); 
		    	// var cPrice = parseFloat(value.value);
		    	// var discountPercent = ((cPrice - xPrice) / cPrice) * 100;
		    	// var discountHTML = '';
		    	// if (discountPercent > 0) {
		    	// 	discountHTML = '<h4 class="discount-percentage-block pfs-dicount">'+Math.round(discountPercent)+'% Off</h4>'; 
		    	// }
		    	itemPriceHtml = '<div class="customBundlePrice saleBundle">'+
                	'<span class="product--from customPrice">From </span>'+
	                '<span class="product--compare-price" type="bundlePrice">'+customMoney(comparePrice)+'</span>'+
                	'<span class="product--price price-on-sale" type="bundlePrice">'+customMoney(listPrice)+'</span>'+
              		'</div>';    	
              	bundleFlag = true;	
              	priceType = 'Bundle Custom Compare';
		  	}
		  	if (value.key == 'bundlr_percentage_discount') {
		  		
		  		var parsedValue = JSON.parse(value.value);
		  		if (parsedValue.length != undefined) {
		  			parsedValue = parseInt(parsedValue[0]);
		  		} 
		  		if (parsedValue > 0) {
			  		var bundlrPercentageModifier = (100 - parsedValue) / 100;

			  		listPrice = data.price_min * bundlrPercentageModifier;
			  		comparePrice = parseFloat(data.price_min_aud);
			  		itemPriceHtml = '<span class="product--compare-price" type="bundlrPercentage">'+customMoney(comparePrice)+'</span>'+
	                				'<span class="product--price price-on-sale" type="bundlrPercentage">'+customMoney(listPrice)+'</span>';
	                bundleFlag = true;			
	                priceType = 'Bundle Percentage Discount';	
	                discountPercentage = bundlrPercentageModifier;
	                //console.log('bbbbbbbbbbbbbbbbb', listPrice, comparePrice);
                }	
                //console.log('bbbbbbbbbbbbbbbbb', data.title, parsedValue);
                
		  	}	
		  	if (value.key == 'discounted_fixed_price') {
		  		//listPrice = value.value;
		  		listPrice = JSON.parse(value.value);
		  		if (listPrice.length != undefined) {
		  			listPrice = parseInt(listPrice[0]);
		  		} 

		  		//console.log('discounted_fixed_price', listPrice);

		  		comparePrice = parseFloat(data.price_min_aud);
		  		itemPriceHtml = '<span class="product--compare-price" type="bundlrFixed">'+customMoney(comparePrice)+'</span>'+
                				'<span class="product--price price-on-sale" type="bundlrFixed">'+customMoney(listPrice)+'</span>';
                bundleFlag = true;		
                priceType = 'Bundle Fixed Discount';		
                customFixedPrice = listPrice;		
		  	}	
		});	

		if (bundleFlag == false) {
			comparePrice = parseFloat(data.compare_at_price_min_aud);
			listPrice = parseFloat(data.price_min_aud);
			if (comparePrice === null) {
				comparePrice = 0;
			}	
			if (comparePrice > listPrice) {
				// normal sale price
				itemPriceHtml = '<span class="product--compare-price" type="normalPrice">'+customMoney(comparePrice)+'</span>'+
                				'<span class="product--price price-on-sale" type="normalPrice">'+customMoney(listPrice)+'</span>';
                priceType = 'Normal Sale';				

			} else {
				listPrice = parseFloat(data.price_min_aud);
				itemPriceHtml = '<span class="product--price" type="normalPrice">'+customMoney(listPrice)+'</span>';
			}	

		}
		

		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Hover Image
		var itemHoverImage = boostPFSConfig.custom.hover_image_enable ? buildItemImage(data, 'hover') : '';
		itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, itemHoverImage);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{discountMod}}/g, discountMod); 
		itemHtml = itemHtml.replace(/{{fixedPrice}}/g, fixedPrice); 

		// Add Product Form
		var itemProductForm = '';
		var hasSizeOptions = false;
		//console.log(data.title);
		//console.log(data.options[0]);
		if (data.options.length == 1 && data.options[0] == 'size') {
			hasSizeOptions = true;
		}

		
		var variants = data.variants;
		var styleATC = 'display: block'; 

		var productVar = '';
		var productVarArr = [];

		// loop variant metafields
		$.each(data.metafields, function( key, value ) {
			if (value.key == 'trimmed_variant') {
		    	if (value.value.length > 0) {
					productVar = value.value.toUpperCase();
					productVarArr = value.value.toUpperCase().split(', ');
		    	}
		  	}
		});
		
		

		//console.log('variant', data.title, data);
		if (data.available == true) {
			var exchRate = parseFloat(window.Shopify.currency.rate);
			var moneyDecimal = true;
			if (theme.currencySettings.money_format.indexOf('amount_no_decimals') > -1) {
			  moneyDecimal = false;
			}
			//itemProductForm += '<input class="quick-buy-button" type="submit" value="' + theme.translations.add_to_cart + '" >';
			itemProductForm += '<div class="product-page--cart-form">';
			itemProductForm += '<form method="post" action="/cart/add" id="product_form_' + data.id + '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">';
			itemProductForm += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';

			// Variants
			
			itemProductForm += '<div class="variants">';
		
			if (hasSizeOptions && data.available) {
				//styleATC = 'display: none';
				itemProductForm += '<div class="size-button-container">';
				console.log('variant', data.title, data);
				//console.log('variants.lengthaaaa:'+variants.length);
				for (var x = 0; x < variants.length; x++) {
					//console.log(variants[x]);
					// compare_at_price

					var buttonTitle = variants[x].title;
					var buttonClass = '';

					// Set Button Title/text
					if (variants.length == 1) {
						buttonTitle = "One Size";
					} else {
						switch(buttonTitle) {
							case 'SMALL':
								buttonTitle = 'S';
							break;
							case 'MEDIUM':
								buttonTitle = 'M'
							break;
							case 'LARGE':
								buttonTitle = 'L'
							break;
							default:
								buttonTitle = buttonTitle;
						}
					}
					// set variant metafields if not blank
					//console.log('buttonTitle:'+buttonTitle);

					if (productVarArr.length > 0) {
						buttonTitle = productVarArr[x];
						//console.log('buttonTitle:'+buttonTitle);
					} 
					
					// Set Default Selected Variant
					if (x == 0) {
						buttonClass += 'selected';
					}

					// Check if Available
					if (variants[x].available == false) {
						buttonClass += ' unavailable';
					}
					var saleClass = '';
					if (variants[x].compare_at_price > variants[x].price) {
						saleClass += ' saleVariant ';
					}

					
					/*
					var variantPriceHtml = '';
					var variantPriceMarket = parseFloat(variants[x].price_aud)*exchRate;   
					if (moneyDecimal == false) {
						variantPriceMarket = variantPriceMarket.toFixed(0);
						variantPriceMarket = parseInt(variantPriceMarket);
					}
					//variantPriceMarket = Utils.formatMoney(variantPriceMarket);
					//variantPriceMarket = extractNumberFromCurrencyString(variantPriceMarket)
					//variantPriceMarket = parseFloat(variantPriceMarket)
					//console.log(data);

                    if (variants[x].compare_at_price > variants[x].price) {
                    	var priceAUD = variants[x].price_aud;
						var variantPriceConv = parseFloat(priceAUD)*exchRate; 
						if (moneyDecimal == false) {
							variantPriceConv = variantPriceConv.toFixed(0);
							variantPriceConv = parseInt(variantPriceConv);
						}

						var priceAUDCompare = variants[x].compare_at_price_aud;
						var variantPriceConvCompare = parseFloat(priceAUDCompare)*exchRate;   
						if (moneyDecimal == false) {
							variantPriceConvCompare = variantPriceConvCompare.toFixed(0);
							variantPriceConvCompare = parseInt(variantPriceConvCompare);
						}

                    	variantPriceHtml = 	'<span class="product--compare-price cccc" data-val="'+priceAUDCompare+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variantPriceConvCompare)+currencyCode+'</span>'
				                            +'</span>'   
				                            +'<span class="product--price price-on-sale vvv 1111" data-val="'+priceAUD+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variantPriceConv)+currencyCode+'</span>'
				                            +'</span>';
					} else {
						var priceAUD = variants[x].price_aud;
						var variantPriceConv = parseFloat(priceAUD)*exchRate;   
						if (moneyDecimal == false) {
							variantPriceConv = variantPriceConv.toFixed(0);
							variantPriceConv = parseInt(variantPriceConv);
						}
						variantPriceHtml = 	'<span class="product--price 000" data-val="'+priceAUD+'">'
                                				+'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variantPriceConv)+currencyCode+'</span>'
                            				+'</span>';
                        if (discountMod < 1) {

                        	variantPriceHtml = 	'<span class="product--compare-price cccc" data-val="'+variants[x].price+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variantPriceMarket)+currencyCode+'</span>'
				                            +'</span>'   
				                            +'<span class="product--price price-on-sale vvv 2222" data-val="'+variants[x].price * discountMod+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variantPriceMarket * discountMod)+currencyCode+'</span>'
				                            +'</span>';
				                        
    
                        }   
                        if (fixedPrice > 1) {
                        	variantPriceHtml = 	'<span class="product--compare-price cccc" data-val="'+variants[x].price+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(variants[x].price)+currencyCode+'</span>'
				                            +'</span>'   
				                            +'<span class="product--price price-on-sale vvv 3333" data-val="'+Math.trunc(fixedPrice*exchRate)+'">'
				                                +'<span class="money" data-currency="'+Currency.currentCurrency
+'">'+Utils.formatMoney(Math.trunc(fixedPrice*exchRate))+currencyCode+'</span>'
				                            +'</span>';
                        }   

					}
					*/
					var variantPriceHtml = 'bundleFlag '+bundleFlag + ' | '+priceType;
					var variantListPrice = parseFloat(variants[x].price_aud);
					var variantComparePrice = variants[x].compare_at_price_aud;
					if (variantComparePrice === null || variantComparePrice === undefined) {
						variantComparePrice = 0;
					}	
					var variantComparePrice = parseFloat(variantComparePrice);

					//console.log('normal price', data.title, variantListPrice, variantComparePrice); 
					if (variantComparePrice < variantListPrice) {
						variantPriceHtml = '<span class="product--price" type="normalPrice" data-val="'+variantListPrice+'">'+customMoney(variantListPrice)+'</span>';
					}	else {
						variantPriceHtml = '<span class="product--compare-price" type="normalPrice" data-val="'+variantComparePrice+'">'+customMoney(variantComparePrice)+'</span>'+
                				'<span class="product--price price-on-sale" type="normalPrice" data-val="'+variantListPrice+'">'+customMoney(variantListPrice)+'</span>';		
					}

					if (priceType == 'Bundle Percentage Discount') {
						variantListPrice = parseFloat(variants[x].price_aud) * discountPercentage;
						variantComparePrice = parseFloat(variants[x].price_aud);
						variantPriceHtml = '<span class="product--compare-price" type="bundlrPercentage" data-val="'+variantComparePrice+'">'+customMoney(variantComparePrice)+'</span>'+
                				'<span class="product--price price-on-sale" type="bundlrPercentage" data-val="'+variantListPrice+'">'+customMoney(variantListPrice)+'</span>';

					} else if (priceType == 'Bundle Fixed Discount') {
						variantListPrice = customFixedPrice;
						variantComparePrice = parseFloat(variants[x].price);
						//console.log('Bundle Fixed Discount', data, variants[x]);
						variantPriceHtml = '<span class="product--compare-price" type="bundlrFixed" data-val="'+variantComparePrice+'">'+customMoney(variantComparePrice)+'</span>'+
                				'<span class="product--price price-on-sale" type="bundlrFixed" data-val="'+variantListPrice+'">'+customMoney(variantListPrice)+'</span>'; 
					}
					//variantPriceHtml = priceType+'<br>'+discountPercentage+'<br>'+variantPriceHtml;


					itemProductForm += '<a class="size-button '+ saleClass + buttonClass + '" href="#" data-value="' + variants[x].id + '" data-title="' + variants [x].title + '">'
										+ '<span class="variant--price-wrapper">'+ variantPriceHtml  +'</span>' 
										+ buttonTitle + '</a>';
				}

				itemProductForm += '</div>';
			} 


			// Select Field
			var hasSelected = false;
			itemProductForm += '<select name="id" class="medium variant-listbox">';
			for (var y = 0; y < variants.length; y++) {
				var optionData = '';

				// Check if variant is available
				if (variants[y].inventory_quantity <= 0 && variants[y].available == false) {
					optionData += 'DISABLED';
				}

				// Check if frist variant
				if (variants[y].available && hasSelected == false) {
					optionData += ' selected="selected"';
					hasSelected = true;
				}

				itemProductForm += '<option data-sku="' + variants[y].sku + '" ' + optionData + ' value="' + variants[y].id + '" data-inventory-quantity="' + variants[y].inventory_quantity + '">' + variants[y].title + ' - ' + Utils.formatMoney(variants[y].price) + '</option>';
			}

			itemProductForm += '</select>';

			itemProductForm += '</div>';

			itemProductForm += '<div class="product-low-in-stock"></div>';
			itemProductForm += '<div id="infiniteoptions-container"></div>';

			// Add to cart button
			var hiddenClass = '';

			if (hasSizeOptions) {
				hiddenClass = 'hidden'
			}

			//itemProductForm += '<div class="quanity-cart-row clearfix ' + hiddenClass + '"><div class="add-to-cart">';
			itemProductForm += '<div class="quanity-cart-row clearfix" style="'+styleATC+'"><div class="add-to-cart">'; 

			var buttonHTML = '<input class="button" type="submit" name="add" value="'+theme.translations.add_to_cart+'" >';
			if (data.tags.indexOf('coming_soon') >= 0) {
				buttonHTML = '<input class="sold-out-item coming-soon" type="submit" disabled="disabled" value="' + theme.translations.coming_soon + '" >'; 
			}
			if (data.tags.indexOf('restocking_soon') >= 0) {
				buttonHTML = '<input class="sold-out-item coming-soon" type="submit" disabled="disabled" value="' + theme.translations.restocking_soon + '" >'; 
			}	
			itemProductForm += buttonHTML;
			itemProductForm += '</div></div>' 

			itemProductForm += '</form>';
			itemProductForm += '</div>';

			//itemProductForm += '<input class="quick-buy-button" type="submit" value="' + theme.translations.add_to_cart + '" >';
		} else {
			var diableBtnValueText = '';

			if (data.tags.indexOf('coming_soon') >= 0) {
				diableBtnValueText = theme.translations.coming_soon;
			} else if (data.tags.indexOf('restocking_soon') >= 0) {
				diableBtnValueText = theme.translations.restocking_soon;
			} else {
				diableBtnValueText = theme.translations.sold_out;
			}
			itemProductForm += '<div class="product-page--cart-form">'; 
			itemProductForm += '<div class="variants">';
			itemProductForm += '</div>';
				
			itemProductForm += '<input class="sold-out-item" type="submit" disabled="disabled" value="' + diableBtnValueText + '" >';
			itemProductForm += '</div>';
		}
		//console.log(itemProductForm);
		if (hasSizeOptions) {
			itemHtml = itemHtml.replace(/{{withSize}}/g, 'with-size-variant');
		} else {
			itemHtml = itemHtml.replace(/{{withSize}}/g, '');
		}

		// Check if 'no-quick-add' tag is existing, if yest, don't display the quick add button
		if (data.tags.indexOf('no-quick-add') <= -1) {
			itemHtml = itemHtml.replace(/{{productForm}}/g, itemProductForm);
		} else {
			itemHtml = itemHtml.replace(/{{productForm}}/g, '');
		}


		var discountPrecentageBlock = '';
		if (comparePrice > listPrice) {
			var discountPercentageAmount = Math.round(((comparePrice - listPrice)/comparePrice) * 100);
			discountPrecentageBlock = '<div class="discount-percentage-block pfs-dicount2">' + discountPercentageAmount + theme.translations.percentage_off +'</div>'; 
		}	
		itemHtml = itemHtml.replace(/{{discountPercentage}}/g, discountPrecentageBlock);

		var pTagVal = '';
		$.each(data.tags, function( key, value ) {
			if (key == 0) {
		    pTagVal += value.toLowerCase();
		  } else {
		    pTagVal += ', '+value.toLowerCase();
		  }
		});

		


		// Add main attribute
		itemHtml = itemHtml.replace(/{{productTags}}/g, pTagVal);
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, metaFormattedTitle);
		itemHtml = itemHtml.replace(/{{sustainTag}}/g, sustainTag);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {

		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (boostPFSFilterConfig.general.hybridPagination == true && boostPFSFilterConfig.general.paginationType == 'default') {	    	
	      	if (totalPage > 1) {
	      		paginationHtml2 = boostPFSTemplate.paginateHtml2;
	      		//console.log(paginationHtml2);
		        // Build Previous
				var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
				previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
				paginationHtml2 = paginationHtml2.replace(/{{previous}}/g, previousHtml);

				// Build Next
				var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
				nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
				paginationHtml2 = paginationHtml2.replace(/{{next}}/g, nextHtml);

				paginationHtml2 = paginationHtml2.replace(/{{selectBox}}/g, currentPage);

		        // Build page items
		        var pageItemsHtml = '';
		        paginationHtml2 = paginationHtml2.replace(/{{pageItems}}/g, pageItemsHtml);
		        paginationHtml2 = paginationHtml2.replace(/{{totalPage}}/g, totalPage);

		        $('.upperPagination').html(paginationHtml2);
	      	}	
	    }	

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Build first
			var firstHtml = (currentPage > 1) ? boostPFSTemplate.firstActiveHtml : boostPFSTemplate.firstDisabledHtml;
			firstHtml = firstHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{first}}/g, firstHtml);


			// Build last
			var lastHtml = (currentPage == totalPage) ? boostPFSTemplate.lastDisabledHtml : boostPFSTemplate.lastActiveHtml;
			lastHtml = lastHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, totalPage));
			paginationHtml = paginationHtml.replace(/{{last}}/g, lastHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage in pageArr) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			var paginationWord = boostPFSTemplate.paginateWord;
			paginationWord = paginationWord.replace(/{{selectBox}}/g, currentPage);
			paginationWord = paginationWord.replace(/{{totalPage}}/g, totalPage);

			$('.pageIndicator').html(paginationWord);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}

		return '';
	};

	// Build srcset
	// @data = data.images_info
	function getSrcsetUrl(data) {
		var arr = [];
		var listImageWidth = getListImageWidth(data);
		var len = listImageWidth.length;
		var url = '';

		if (data != null) {
			for (var i = 0; i < len; i++) {
				url = data.src.substring(0, data.src.lastIndexOf('.'));
				url += '_' + listImageWidth[i] + 'x';
				url += data.src.substring(data.src.lastIndexOf('.'));
				url += ' ' + listImageWidth[i] + 'w';
				arr.push(url);
			}
		}

		return arr;
	}

	// Get Aspect Ratio based on Dimensions
	// @data = data.images_info
	function getAspectRatio(data) {
		var width = (data == null) ? '600' : data.width;
		var height = (data == null) ? '400' : data.height;
	
		return width / height;
	}

	// Get Image Width List
	// @data = data.images_info
	function getListImageWidth(data) {
		var arr = [295, 394, 590, 700, 800, 1000, 1200, 1500, 1800, 2000, 2400];
		var arr_len = arr.length;
		var rs = [];
	
		if (data != null) {
			for (var i = 0; i < arr_len; i++) {
				var width_init = arr[i] + 0;

				if (data.width > width_init) {
					rs.push(width_init);
				}
			}
			rs.push(data.width);
		}

		return rs;
	}

	function buildItemImage(data, type) {
		var itemImage = '';
		var index = Object.keys(data.images);
		var imgWidth = (data.images_info[0] == null) ? '600' : data.images_info[0].width;

		// Calculate padding-top based on aspect ratio
		var pad_top = 1 / getAspectRatio(data.images_info[0]) * 100;

		// Image Section
		if (type !== 'image') {
			itemImage += '<div class="product--hover-image">';
		}

		itemImage += '<div class="image--root" data-aspectratio="' + getAspectRatio(data.images_info[0]) + '" style="width:' + imgWidth + 'px">';
		itemImage += '<div class="image--container" style="padding-top:' + pad_top + '%">';
	
		// Get image src (type='image') & hover image src
		if (type === 'image') {
			if (index.length > 0) {
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + data.images[1]  
							+ '" data-src="' + getSrcsetUrl(data.images_info[0])
							+ '" srcset="' + getSrcsetUrl(data.images_info[0])
							+ '" alt="' + data.title + '">';
			} else { 
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + boostPFSConfig.general.no_image_url 
							+ '" data-src="' + getSrcsetUrl(data.images_info[0])
							+ '" srcset="' + getSrcsetUrl(data.images_info[0])
							+ '" alt="' + data.title + '">';
			}   
		} else {    
			if (index.length > 0) {
				itemImage += '<img class="lazypreload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + data.images[index.length] 
							+ '" data-src="' + getSrcsetUrl(data.images_info[1])
							+ '" srcset="' + getSrcsetUrl(data.images_info[1])
							+ '" alt="' + data.title + '">';
			} else {
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + boostPFSConfig.general.no_image_url 
							+ '" data-src="' + getSrcsetUrl(data.images_info[1])
							+ '" srcset="' + getSrcsetUrl(data.images_info[1])
							+ '" alt="' + data.title + '">';
			}   
		}  
	
		if (type !== 'image') {
			itemImage += '</div>';
		}
		itemImage += '</div></div>';

		return itemImage; 
	}

	// Build additional attributes of product items
	ProductList.prototype.afterRender = function(data) {

		if (!data) data = this.data;
		$(".product--image-wrapper").each(function() {
			$(this).on('mouseover mouseout', function() {
				var item = $(this).children('.product--hover-image');

				if (item.length > 0) {
					if (event.type == 'mouseover') {
						$(item).attr('style', 'opacity: 1');
					} else {
						$(item).attr('style', 'opacity: 0');
					}
				}
			});
		});


		$('.size-button-container').each(function() {
			if (Globals.queryParams.pf_opt_size != undefined) {
				var currentSizeFilter = Globals.queryParams.pf_opt_size.slice(-1)[0];	
				var sizeUnAvail = $(this).find('.size-button[data-title="'+currentSizeFilter+'"]').hasClass('unavailable');
				console.log(sizeUnAvail);
				if (sizeUnAvail) {
					//console.log('unavailable');
					$(this).find('.size-button').not('.unavailable').first().trigger('click');
				} else {
					//console.log('available');
					$(this).find('.size-button[data-title="'+currentSizeFilter+'"]').trigger('click');
				}

			} else {
				$(this).find('.size-button').not('.unavailable').first().trigger('click');
			}
		});

		// Display Review Widget
		/*
		var judgeMeBlockCount = $('.judge-me-review-block').length;
		$('.judge-me-review-block').each(function(){
			var itemHandle = $(this).attr('data-handle');
			var thisElem = $(this);

			$.get('https://judge.me/api/v1/widgets/preview_badge', {
				"api_token": "1Tjx-4hzqWXq0l-_Rpa1SFdM0P8",
				"shop_domain": "stylish-hound-com.myshopify.com",
				"handle": itemHandle
			}).done(function(res){
				$(thisElem).html(res.badge);

				// Callback if the loop is done
				if (!--judgeMeBlockCount) {
					$('.product--title').matchHeight({byRow: true});
			    	$('.product--details-inner').matchHeight({byRow: true});
				}
			});
		});
		*/

		$('.collection-grid-product-form .variants').matchHeight({byRow: true});

		// Display Bundle Price
		/*
		$('.collection-bundle-price').each(function(){
			var bundleUrl = $(this).attr('data-url');
			$(this).load(bundleUrl + '?view=bundle-price #bundlePriceData', function() {
				if (Shopify.currency.active != 'AUD' ) {
					//alert('converttttttt');
					//Currency.convertAll(shopCurrency, cookieCurrency);
					var exchRate = parseFloat(window.Shopify.currency.rate);
					$('[data-market-price]').each(function() {
						var thisAmt = parseInt(Math.round($(this).attr('data-market-price')));
						var thisAmtConv = thisAmt * exchRate;
						$(this).html(Shopify.formatMoney(thisAmtConv, shop_money));
					});

				}
				
			});
		});
		*/
    	if (cookieCurrency != null) {
    		if (cookieCurrency != 'AUD' ) {
  				//Currency.convertAll(shopCurrency, cookieCurrency);
  			}	
		}
		renderBadge();
		
    
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		var currentPage = parseInt(Globals.queryParams.page);
	    var totalPage = Math.ceil(Globals.collectionCount / Globals.queryParams.limit);

		setTimeout(function() {
			$('.boost-pfs-filter-option-first-level-list > li >  .boost-pfs-filter-option-item').addClass('boost-pfs-open');
		}, 1);
		if ($('.boost-pfs-filter-collection-description').html() != undefined) {
      		var descHTML = $('.boost-pfs-filter-collection-description').html().split('<!-- split -->');
      		
			$('.collection .topDesc').html(descHTML[0]);
			$('.collection .bottomDesc').html(descHTML[1]);
    	}
	    // if hybridPagination default
	    if (boostPFSFilterConfig.general.hybridPagination == true && boostPFSFilterConfig.general.paginationType == 'default') {
		    $('.upperPagination').html(paginationHtml2);
	    }	
	    // if hybridPagination load more
	    if (boostPFSFilterConfig.general.hybridPagination == true && boostPFSFilterConfig.general.paginationType == 'load_more') {
	      var currentPage = parseInt(Globals.queryParams.page);
	      var totalPage = Math.ceil(Globals.collectionCount / Globals.queryParams.limit);
	      if (totalPage > 1) {
	        var paginationHtml = boostPFSTemplate.paginateHtml;

	        // Build Previous
	        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
	        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
	        if ($('.boost-pfs-filter-btn-load-previous-page:visible').length == 0) {
	          previousHtml = '';
	        }
	        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
	        

	        // Build Next
	        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
	        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
	        if ($('.boost-pfs-filter-load-more:visible').length == 0) {
	          nextHtml = '';
	        }
	        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
	        paginationHtml = paginationHtml.replace(/{{selectBox}}/g, currentPage);
	        // Build page items
	        var pageItemsHtml = '';
	        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
	        paginationHtml = paginationHtml.replace(/{{totalPage}}/g, totalPage);
	        
	        $('.boost-pfs-filter-bottom-pagination').addClass('hybrid').html(paginationHtml);
	        //console.log(paginationHtml);

	        var progressPercent = (currentPage / totalPage) * 100
	        $('.boost-pfs-filter-load-more-total').append('<div class="progressbar"><div style="width: '+progressPercent+'%"></div></div>')
	      }  
	    }
	    // adjust sort
	    var sortValue = $('.boost-pfs-filter-top-sorting-select').val();
	    if (sortValue == null) {
			$('.boost-pfs-filter-custom-sorting').attr('data-label', 'Sort by');  
		} else {
		  $('.boost-pfs-filter-custom-sorting').attr('data-label', $('.boost-pfs-filter-top-sorting-select option:selected').text());   
		}
	};

	Utils.buildProductItemVendorUrl = function(vendor){
		return window.location.protocol + '//' + window.location.hostname + '/collections/vendors?q=' + this.encodeURIParamValue(vendor);
	};

})(jQuery);


$(document).ready(function() {
  renderBadge();
});


$('body').on('change', '.boost-pfs-filter-top-sorting-select', function() {
    var sortValue = $('.boost-pfs-filter-top-sorting-select').val();
    if (sortValue == null) {
		$('.boost-pfs-filter-custom-sorting').attr('data-label', 'Sort');  
	} else {
	  $('.boost-pfs-filter-custom-sorting').attr('data-label', $('.boost-pfs-filter-top-sorting-select option:selected').text());   
	}  
});

$('body').on('click', '.boost-pfs-filter-bottom-pagination.hybrid .arrow.left a', function() {
    $('.boost-pfs-filter-btn-load-previous-page').trigger('click');
    return false;      
  });
  $('body').on('click', '.boost-pfs-filter-bottom-pagination.hybrid .arrow.right a', function() {
    var completeCalled = false;
    $('html, body').animate({
      scrollTop: $('.boost-pfs-filter-load-more').offset().top - $('#shopify-section-header').height()
    }, 600, function() {
      if(!completeCalled){
        completeCalled = true;
        $('.boost-pfs-filter-load-more-button').trigger('click'); 
      }
       
    });
    
    return false;      
  });



function renderBadge() {
	$('.product--root').each(function() {
		//console.log('tag:'+$(this).attr('data-tag'));
		var tagArr = '';
		if ($(this).attr('data-tag') != undefined) {
			tagArr = $(this).attr('data-tag').split(', ');	
		}
	  	var pCard = $(this);
	  	var badgeCode = '';
	  	pCard.find('.product--price-wrapper h5').remove(); 
      	pCard.find('.product--price-wrapper .collection-bundle-price h5').remove();
  		pCard.find('.badgeBox').remove();
  
		$.each(theme.labelSettings.badgeConfig, function( key, value ) {
	    // array found
	    	//console.log(value.tag);
	    	if ($.inArray(value.tag, tagArr) > -1) {
	    		//console.log(value.tag);  

	      		if (value.type == 'text') {
	        		// if discount 
	        		if (value.collection != '') {
	                	if (value.collection == theme.labelSettings.collectionHandle) {
	 	 					badgeCode = '<h5 style="background-color: '+value.bg+'; color: '+value.color+'"><span>'+value.title+'</span></h5>'
	       					pCard.find('.product--price-wrapper').append(badgeCode);			
						}
	              	} else {
                		badgeCode = '<h5 style="background-color: '+value.bg+'; color: '+value.color+'"><span>'+value.title+'</span></h5>';
	       				pCard.find('.product--price-wrapper').append(badgeCode);
	              	}
	        		
	      		}
          		if (value.type == 'round') {
          			if (value.collection != '') {
	                	if (value.collection == theme.labelSettings.collectionHandle) {
	 	 					badgeCode = '<div class="badgeBox" style="border: solid '+value.color+' 8px; background: '+value.bg+'"><svg viewBox="0 0 500 500" width="100" height="100"> <defs> <path id="circle" d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"/> </defs> <text x="0" y="0" text-anchor="middle" text-rendering="optimizeLegibility"> <textPath xlink:href="#circle" startOffset="50%" fill="'+value.color+'">'+value.title+'</textPath> </text></svg></div>'
            				pCard.find('.product--image-wrapper').append(badgeCode);
						}
	              	} else {
                		badgeCode = '<div class="badgeBox" style="border: solid '+value.color+' 8px; background: '+value.bg+'"><svg viewBox="0 0 500 500" width="100" height="100"> <defs> <path id="circle" d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"/> </defs> <text x="0" y="0" text-anchor="middle" text-rendering="optimizeLegibility"> <textPath xlink:href="#circle" startOffset="50%" fill="'+value.color+'">'+value.title+'</textPath> </text></svg></div>'
            			pCard.find('.product--image-wrapper').append(badgeCode);
	              	}
          		}  
	    	}

		});
	});

	if (Shopify.currency.active != 'AUD' ) {
		//alert('converttttttt');
		//Currency.convertAll(shopCurrency, cookieCurrency);
		var exchRate = parseFloat(window.Shopify.currency.rate);
		$('[data-market-price]').not('.converted').each(function() {
			var thisAmt = parseInt(Math.round($(this).attr('data-market-price')));
			var thisAmtConv = thisAmt * exchRate;
			$(this).addClass('converted').html(Shopify.formatMoney(thisAmtConv, shop_money_format));
			//console.log('thisAmtConv:'+thisAmtConv);
		});

	}
	$('.product--title').matchHeight({byRow: true});
  	$('.product--details-inner').matchHeight({byRow: true});
  	$('.collection-grid-product-form .variants').matchHeight({byRow: true});

}

function extractNumberFromCurrencyString(str) {
    // Remove any currency symbols and commas
    const cleanedStr = str.replace(/[^\d.-]/g, '');
    
    // Convert the cleaned string to a number
    const number = parseFloat(cleanedStr);
    
    // Check if the result is a valid number
    return isNaN(number) ? null : number;
}


